export const REQUEST_MASTER_MARKETING = "REQUEST_MASTER_MARKETING";
export const SET_MASTER_MARKETING = "SET_MASTER_MARKETING";
export const ERROR_GET_MASTER_MARKETING = "ERROR_GET_MASTER_MARKETING";

export const REQUEST_CREATE_MASTER_MARKETING =
  "REQUEST_CREATE_MASTER_MARKETING";
export const SUCCESS_CREATE_MASTER_MARKETING =
  "SUCCESS_CREATE_MASTER_MARKETING";
export const ERROR_CREATE_MASTER_MARKETING = "ERROR_CREATE_MASTER_MARKETING";

export const REQUEST_UPDATE_MASTER_MARKETING =
  "REQUEST_UPDATE_MASTER_MARKETING";
export const SUCCESS_UPDATE_MASTER_MARKETING =
  "SUCCESS_UPDATE_MASTER_MARKETING";
export const ERROR_UPDATE_MASTER_MARKETING = "ERROR_UPDATE_MASTER_MARKETING";

export const REQUEST_DELETE_MASTER_MARKETING =
  "REQUEST_DELETE_MASTER_MARKETING";
export const SUCCESS_DELETE_MASTER_MARKETING =
  "SUCCESS_DELETE_MASTER_MARKETING";
export const ERROR_DELETE_MASTER_MARKETING = "ERROR_DELETE_MASTER_MARKETING";

export const SET_MESSAGE_MASTER_MARKETING = "SET_MESSAGE_MASTER_MARKETING";
